import React from 'react'
import '../../App.css'

export default function Prototype() {
    return <h1 className="prototype">Prototype</h1>
}